import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useProviderLoader } from '@/Providers/useProviderLoader'
import { useToast } from '@/context/ToastContext'
import { useAuthHook } from '@/hooks/useAuthHook'

export const useAgentLogin = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { login: loginContext } = useAuthHook()
    const { showLoader, hideLoader } = useProviderLoader()
    const { showToast } = useToast()

    const [status, setStatus] = useState<'processing' | 'error' | 'success'>(
        'processing'
    )
    const [title, setTitle] = useState(t('agentImpersonate.title'))
    const [message, setMessage] = useState(t('agentImpersonate.processing'))

    const handleAgentLogin = async (
        accessToken: string | null,
        password: string | null,
        idAsesor: string | null
    ) => {
        if (!accessToken || !password || !idAsesor) {
            setStatus('error')
            setTitle(t('agentImpersonate.error'))
            setMessage(t('agentImpersonate.missingParams'))

            return
        }

        try {
            showLoader()
            const response = await loginContext({
                tokenAccess: accessToken,
                password,
                idAsesor: parseInt(idAsesor),
                isAgentLogin: true
            })

            if (response.status !== 200) {
                handleError(response.message?.[0]?.messageDesc || '')

                return
            }

            handleSuccess()
        } catch (_error) {
            handleError(t('agentImpersonate.systemError'))
        } finally {
            hideLoader()
        }
    }

    const handleError = (errorMessage: string) => {
        setStatus('error')
        setTitle(t('agentImpersonate.error'))
        setMessage(errorMessage)
        showToast({
            title: t('agentImpersonate.error'),
            message: errorMessage,
            type: 'error'
        })
    }

    const handleSuccess = () => {
        setStatus('success')
        setTitle(t('agentImpersonate.success'))
        setMessage(t('agentImpersonate.successDescription'))
        setTimeout(() => navigate('/initial-inscription'), 1500)
    }

    return {
        status,
        title,
        message,
        handleAgentLogin
    }
}
